import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { TransactionProvider } from "./contexts/TransactionContext";
import { BudgetProvider } from "./contexts/BudgetContext";
import { AccountProvider } from "./contexts/AccountContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { GoalProvider } from "./contexts/GoalContext";
import { BillProvider } from "./contexts/BillContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import { FamilyProvider } from "./contexts/FamilyContext";
import { PrivateRoute } from "./components/PrivateRoute";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Transactions from "./pages/Transactions";
import Stats from "./pages/Stats";
import Accounts from "./pages/Accounts";
import Settings from "./pages/Settings";
import Insights from "./pages/Insights";
import Goals from "./pages/Goals";
import Bills from "./pages/Bills";
import Subscriptions from "./pages/Subscriptions";
import FamilyBudget from "./pages/FamilyBudget";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <CurrencyProvider>
          <TransactionProvider>
            <BudgetProvider>
              <AccountProvider>
                <GoalProvider>
                  <BillProvider>
                    <SubscriptionProvider>
                      <FamilyProvider>
                        <BrowserRouter>
                          <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route 
                              path="/transactions" 
                              element={
                                <PrivateRoute>
                                  <Transactions />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/stats" 
                              element={
                                <PrivateRoute>
                                  <Stats />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/insights" 
                              element={
                                <PrivateRoute>
                                  <Insights />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/accounts" 
                              element={
                                <PrivateRoute>
                                  <Accounts />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/settings" 
                              element={
                                <PrivateRoute>
                                  <Settings />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/goals" 
                              element={
                                <PrivateRoute>
                                  <Goals />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/bills" 
                              element={
                                <PrivateRoute>
                                  <Bills />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/subscriptions" 
                              element={
                                <PrivateRoute>
                                  <Subscriptions />
                                </PrivateRoute>
                              } 
                            />
                            <Route 
                              path="/family" 
                              element={
                                <PrivateRoute>
                                  <FamilyBudget />
                                </PrivateRoute>
                              } 
                            />
                            <Route path="/" element={<Login />} />
                            <Route path="*" element={<Navigate to="/login" replace />} />
                          </Routes>
                          <Toaster position="top-center" />
                        </BrowserRouter>
                      </FamilyProvider>
                    </SubscriptionProvider>
                  </BillProvider>
                </GoalProvider>
              </AccountProvider>
            </BudgetProvider>
          </TransactionProvider>
        </CurrencyProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
